import buildConfig, { BaseAppConfig } from "./base";

const baseApi = "https://api.usewinslow.com/api";
const env = buildConfig(baseApi);

export default {
  ...env,
  environment: "production",
  redirect: "https://app.usewinslow.com/signup",
  clientUrl: "https://app.usewinslow.com",
  hostname: "app.usewinslow.com",
  showContents: false,
  allowNewWorkspace: true,
  wsCaptureUrl: "wss://api.usewinslow.com/ws/assets/capture",
  wsRefreshUrl: "wss://api.usewinslow.com/ws/shares/connect",
  wsPolicyStudioUrl: "wss://api.usewinslow.com/ws/ps/policy-studio",
  wsAiUrl: "wss://api.usewinslow.com/ws/ai/ask",
  wsAgentUrl: "wss://api.usewinslow.com/ws/agent/ask",
  //add overrides here
  slackTestingMode: false,
  showReportCard: false,
  showGoogleDrive: true,
  showWebsiteIngest: false,
  showPersonas: true,
  showSlack: false,
  showUrlMultiInput: true,
  showPolicyStudio: true,
  killPolicyStudio: false,
  enforceHrisIntegration: true,
  showLinkRecordLogs: false,
} as BaseAppConfig;
